// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-track-properties {
  display: flex;
  flex-direction: column;
  bottom: 0;
  border-radius: 15px;
  background: white;
  width: 100%;
  z-index: 2;
}
wm-track-properties > *:empty {
  display: none;
}
wm-track-properties .wm-track-details-header {
  font-size: var(--font-md);
  color: #333333;
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: center;
  flex: none;
  order: 0;
  flex-grow: 0;
  padding: 10px;
}
wm-track-properties .wm-alert {
  order: -1;
  color: #ff0000;
  display: flex;
  flex-direction: row;
}
wm-track-properties .wm-alert ion-icon {
  font-size: 25px;
  align-self: center;
}
wm-track-properties .wm-alert ion-label {
  align-self: center;
}
wm-track-properties .wm-flowline {
  height: 40px;
}
wm-track-properties .wm-flowline .red {
  color: red;
}
wm-track-properties .wm-flowline .orange {
  color: orange;
}
wm-track-properties .wm-flowline .green {
  color: green;
}
wm-track-properties .webmapp-pagepoi-info-body {
  --padding-bottom: 30px;
}
wm-track-properties .webmapp-pagepoi-info-body .webmapp-pagepoi-info-reference {
  padding: 3px 5px;
  font-size: var(--wm-font-sm);
}
wm-track-properties .webmapp-pagepoi-info-body .webmapp-pagepoi-info-reference a {
  text-decoration: none;
  color: var(--wm-color-dark);
}
wm-track-properties .webmapp-pagepoi-info-body .webmapp-pagepoi-info-reference .webmapp-pagepoi-info-icon {
  color: var(--wm-color-primary);
}
wm-track-properties .webmapp-pagepoi-info-body .webmapp-pagepoi-info-body-photoslider {
  padding: 10px 0;
  overflow: visible;
}
wm-track-properties .webmapp-pagepoi-info-body .webmapp-pagepoi-info-body-photoslider .webmapp-pagepoi-info-body-photo {
  height: 150px;
  width: 250px;
}
wm-track-properties .webmapp-pagepoi-info-body .webmapp-pagepoi-info-body-photoslider .webmapp-pagepoi-info-body-photo::part(image) {
  border-radius: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/track-properties/track-properties.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AACI;EACE,eAAA;EACA,kBAAA;AACN;AACI;EACE,kBAAA;AACN;AAEE;EACE,YAAA;AAAJ;AACI;EACE,UAAA;AACN;AACI;EACE,aAAA;AACN;AACI;EACE,YAAA;AACN;AAEE;EACE,sBAAA;AAAJ;AACI;EACE,gBAAA;EACA,4BAAA;AACN;AAAM;EACE,qBAAA;EACA,2BAAA;AAER;AAAM;EACE,8BAAA;AAER;AACI;EACE,eAAA;EACA,iBAAA;AACN;AAAM;EACE,aAAA;EACA,YAAA;AAER;AADQ;EACE,mBAAA;AAGV","sourcesContent":["wm-track-properties {\n  display: flex;\n  flex-direction: column;\n  bottom: 0;\n  border-radius: 15px;\n  background: white;\n  width: 100%;\n  z-index: 2;\n\n  > *:empty {\n    display: none;\n  }\n\n  .wm-track-details-header {\n    font-size: var(--font-md);\n    color: #333333;\n    font-style: normal;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n    padding: 10px;\n  }\n  .wm-alert {\n    order: -1;\n    color: #ff0000;\n    display: flex;\n    flex-direction: row;\n    ion-icon {\n      font-size: 25px;\n      align-self: center;\n    }\n    ion-label {\n      align-self: center;\n    }\n  }\n  .wm-flowline {\n    height: 40px;\n    .red {\n      color: red;\n    }\n    .orange {\n      color: orange;\n    }\n    .green {\n      color: green;\n    }\n  }\n  .webmapp-pagepoi-info-body {\n    --padding-bottom: 30px;\n    .webmapp-pagepoi-info-reference {\n      padding: 3px 5px;\n      font-size: var(--wm-font-sm);\n      a {\n        text-decoration: none;\n        color: var(--wm-color-dark);\n      }\n      .webmapp-pagepoi-info-icon {\n        color: var(--wm-color-primary);\n      }\n    }\n    .webmapp-pagepoi-info-body-photoslider {\n      padding: 10px 0;\n      overflow: visible;\n      .webmapp-pagepoi-info-body-photo {\n        height: 150px;\n        width: 250px;\n        &::part(image) {\n          border-radius: 15px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
